import PurchaseOrderLists from "../Components/Admin/PurchaseOrderLists";

function PurchaseOrderListPage() {
  return (
    <>
      <PurchaseOrderLists />
    </>
  );
}

export default PurchaseOrderListPage;